import { createContext } from "react";
import { engagementslides, haldislides, mehendislides, products } from "../images/assets";

export const Shopcontext = createContext()

const ShopcontextProvider = (props) => {

    const value = {
        products,
        engagementslides,
        haldislides,
        mehendislides
    }

    return (
        <Shopcontext.Provider value={value}>
            {props.children}
        </Shopcontext.Provider>
    )
}

export default ShopcontextProvider;